module.exports = __webpack_public_path__ + "img/icons8-radar-64.29c8447f.png";